import {Button, Col, Figure, Form, Row} from "react-bootstrap";
import React from "react";
import {ShopPageTitle} from "./_components/ShopPageTitle";
import {useBasket} from "./useShop";
import {Link} from "react-router-dom";
import {config, getPriceWithVat} from "../../utils2";
import {useAlert, useAuth, useDarkMode} from "../../context";
import {ItemLoading, OurClearAlert} from "../_components";
import {AdjustQuantityCart} from "./_components/AdjustQuantity";
import {Formik, Form as FormikForm, FieldArray, Field} from "formik";
import {OrderSummary} from "./_components/OrderSummary";

export function Cart() {
    const {basket, editArticle, errorArticle, loadingArticle, clearErrorArticle} = useBasket()
    const {success, warn} = useAlert()
    const {user} = useAuth()

    function handleSubmit(values, actions) {
        editArticle(values)
            .then(() => {
                if (values.articles && values.articles.length === 0) {
                    warn("Your basket is now empty")
                } else {
                    success("Basket updated")
                }
            })
            .catch(console.warn)
            .finally(() => actions.setSubmitting(false))
    }

    return <div className="mx-2 mx-sm-0">
        <ShopPageTitle title="Shopping Cart" className="mt-2"/>
        <OurClearAlert variant="danger" msg={errorArticle} onClear={clearErrorArticle}/>

        <ItemLoading show={loadingArticle}/>
        {basket?.articles && basket?.articles.length > 0 ? (
            <>
                <Formik onSubmit={handleSubmit} initialValues={basket} enableReinitialize>
                    {({isSubmitting, dirty}) => (
                        <FormikForm>
                            <Row>
                                <Col md={8}>
                                    <FieldArray name="articles" component={RenderArticles}/>

                                    <div className="border-top my-2">
                                        {user?.vat_percentage > 0 ? <div>* VAT included at {user?.vat_percentage}% estimated on your primary address.</div> : <div>* VAT will be calculated based on your billing address at checkout.</div>}
                                        <Button type="submit" variant="primary" disabled={isSubmitting || !dirty} className="ms-auto my-2">Update Cart</Button>
                                    </div>
                                </Col>
                                <Col>
                                    <OrderSummary basket={basket} disabled={isSubmitting || dirty}/>
                                </Col>
                            </Row>
                        </FormikForm>
                    )}
                </Formik>
            </>
        ) : (
            <p>Empty cart.</p>
        )}
    </div>
}


function RenderArticles({form, remove}) {
    const {darkMode} = useDarkMode()
    const {user} = useAuth()

    return (
        form.values.articles.map((article, index) => (
            <div key={index} className="border-top my-2">

                <div className="d-flex align-items-start gap-2">
                    <Figure className="mt-2 mb-0 ms-1">
                        <Figure.Image
                            src={config.get_public_media(article.media_first_path, "thumb", darkMode)}
                            rounded
                            height="150px"
                            width="150px"
                            loading="lazy"
                        />
                    </Figure>

                    <div className="flex-column w-100">
                        <Link to={`/shop/detail/${article.product_id}`}
                              className="flex-shrink-0 link-body-emphasis link-underline link-underline-opacity-0 link-underline-opacity-75-hover link-offset-1 link-offset-1-hover">
                            <div className="text-wrap fs-4">{article.title}</div>
                        </Link>
                            <div className="small">{article.summary}</div>
                        {/*<Alert variant="success" className="p-1"><i className="bi bi-info-circle me-1"/>Product temporary unavailable!</Alert>*/}
                    </div>
                </div>

                <div className="d-flex justify-content-start align-items-center gap-1 mb-2">

                    <Button variant="outline-secondary" className="border-0" onClick={remove}>{form.isSubmitting ?
                        <i className="bi bi-three-dots"/> : <i className="bi bi-trash"/>}</Button>


                    <div className="d-flex align-items-center ms-auto gap-2 gap-md-4">

                        <Field name={`articles.${index}.quantity`}>
                            {({field}) => (
                                <AdjustQuantityCart name={field.name} value={field.value} onChange={field.onChange}/>
                            )}
                        </Field>

                        <div className="">
                            {article.base_price !== article.unit_price ? (
                                <div>
                                    <div className="d-flex flex-wrap">
                                        <div className="text-decoration-line-through text-nowrap small">{getPriceWithVat(article.base_price, user?.vat_percentage)} €</div>
                                        {/*<div className="text-danger ms-2">-{article.unit_price_discount}%</div>*/}
                                    </div>
                                    <div className="text-danger text-nowrap">{getPriceWithVat(article.unit_price, user?.vat_percentage)} €</div>
                                </div>) : <div className="text-nowrap">{getPriceWithVat(article.base_price, user?.vat_percentage)} €</div>}
                        </div>

                        <div className="d-flex align-items-center justify-content-end flex-md-grow-0 flex-grow-1 ">
                            <div className="me-2 d-none d-md-block">Subtotal</div>
                            <div className="text-nowrap">{getPriceWithVat(article.total_price, user?.vat_percentage)} €</div>
                        </div>

                    </div>

                </div>
            </div>
        ))
    )
}

function CouponField({name, tip, className}) {

    return <>
        <Field name={name}>
            {({field, meta}) => <Form.Group className={className}>
                <Form.Label column="" className="text-capitalize">Coupon code</Form.Label>
                <Form.Control type="text" {...field} value={field.value ?? ""} isInvalid={meta.touched && !!meta.error} aria-label="coupon-aria"
                              maxLength={10} className="w-25"/>
                <Form.Control.Feedback type="invalid">{meta.error}</Form.Control.Feedback>
                {tip != null && <Form.Text muted>{tip}</Form.Text>}
            </Form.Group>}
        </Field>
    </>
}
